module.exports = __webpack_public_path__ + "static/media/empty_prescription.ef9da8ea.png";